import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button, Popconfirm, DateValue } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class List extends React.Component {

	@observable records = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.records = await store.model.Appointment.find({ order: 'id desc', include: ['deputy'] });
	};
	
	create = () => this.props.history.push('/admin/appointments/create');
	
	fio = record => <>
		{record.lastName} {record.firstName ? <>{record.firstName.substr(0, 1)}.</> : ''} {record.middleName ? <>{record.middleName.substr(0, 1)}.</> : ''}
	</>;
	
	delete = async record => {
		console.log('delete', record);
		await record.delete();
		this.init();
	};
	
	render() {
		if (!this.records) return '...';
		
		return <>
			<p>Запись на личный прием</p>
			{/*<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>*/}
			<Table records={this.records} rootPath="/admin">
				<Column width={60} property="id" label="id" />
				<Column relation="deputy" computed={this.fio} label="Адресат" />
				<Column width={80} property="date" label="Дата приема"><DateValue format="DD.MM.YYYY" /></Column>
				<Column relation="status" property="name" label="Статус" width={150} />
				<Column computed={this.fio} label="Отправитель" />
				<Column property="email" label="E-mail" />
				{/*<Column property="phone" label="Телефон" />*/}
				{/*<Column property="address" label="Адрес" />*/}
				<Column property="createdAt" label="Создано" />
				{/*<Column property="job" label="Сфера деятельности / место работы" />*/}
				{/*<Column property="socialGroup" label="Социальная группа" />*/}
				{/*<Column property="category" label="Категория" />*/}
				<Column property="subject" label="Тема вопроса" />
				<Column clickable={false}>
					{record => <Popconfirm content="Удалить?" onConfirm={() => this.delete(record)}>
						<a href="#" onClick={e => e.preventDefault()}>Удалить</a>
					</Popconfirm>}
				</Column>
			</Table>
		</>;
	}
	
}
